import React, { useId } from "react";

// Request Spotlight's icon (founder's pick): a screen with a sparkle, in the
// app's 2 px line style, brand green via currentColor. "Hide my name" uses the
// same screen crossed out, with a clean gap cut around the slash.
const PATHS = (
  <>
    <rect x="2.8" y="4" width="18.4" height="12.6" rx="2.4" />
    <path d="M12 16.6V20M8.4 20h7.2" />
    <path d="M12 6.8l.9 2.6 2.6.9-2.6.9-.9 2.6-.9-2.6-2.6-.9 2.6-.9z" />
  </>
);

export function SpotlightIcon({ size = 24 }: { size?: number }) {
  return (
    <svg width={size} height={size} viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true">
      {PATHS}
    </svg>
  );
}

export function SpotlightIconOff({ size = 24 }: { size?: number }) {
  const id = `spot-off-${useId().replace(/[^a-zA-Z0-9_-]/g, "")}`;
  return (
    <svg width={size} height={size} viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true">
      <defs>
        <mask id={id} maskUnits="userSpaceOnUse" x="0" y="0" width="24" height="24">
          <rect width="24" height="24" fill="#fff" />
          <path d="M3 2.6 21 21.4" stroke="#000" strokeWidth="5.2" />
        </mask>
      </defs>
      <g mask={`url(#${id})`}>{PATHS}</g>
      <path d="M3 2.6 21 21.4" />
    </svg>
  );
}
